import React from 'react';
import type { QueryClient } from 'react-query';
import { useQueryClient } from 'react-query';

type PrefetchFunction = (queryClient: QueryClient) => Promise<void>;

export function withPrefetch<Props extends object>(
  Component: React.ComponentType<Props>,
  prefetchFn: PrefetchFunction,
): React.ComponentType<Props> {
  return (props: Props) => {
    const queryClient = useQueryClient();

    void prefetchFn(queryClient);

    return <Component {...props} />;
  };
}
